import { Controller } from "@hotwired/stimulus"
import { Tooltip } from "bootstrap"

// Bootstrap tooltip on the host element (see tooltipize helper).
export default class extends Controller {
  connect() {
    Tooltip.getOrCreateInstance(this.element, {
      container: this.element.dataset.bsContainer || false,
    })

    // Au doigt (apps, mobile), il n'y a pas de survol : l'infobulle d'un bouton n'apparaît qu'à
    // l'appui, puis reste par-dessus ce qu'il ouvre (aperçu, feuille de partage). Celle d'une
    // icône d'information, qu'on touche pour la lire, reste.
    const actionable = this.element.matches("a, button") || this.element.querySelector("a, button")
    if (actionable && window.matchMedia("(hover: none)").matches) {
      this.preventShow = (event) => event.preventDefault()
      this.element.addEventListener("show.bs.tooltip", this.preventShow)
    }
  }

  disconnect() {
    if (this.preventShow) this.element.removeEventListener("show.bs.tooltip", this.preventShow)
    Tooltip.getInstance(this.element)?.dispose()
  }
}
